import React from 'react';

const Footer = () => (
  <footer className="footer">
    <div className="container-fluid">
      <div className="pull-left flip footer-brand">
        <a href="http://www.un.org" title="United Nations">
          <span className="site-name">United Nations</span>
        </a>
      </div>
      <div className="pull-right flip">
        <section className="region region-footer-5">
          <div id="block-menu-menu-footer-links" className="block block-menu">
            <ul className="menu nav">
              <li className="first leaf">
                <a href="https://www.un.org/disarmament/about/contact/">
                  Contact UNODA
                </a>
              </li>
              <li className="leaf">
                <a href="http://www.un.org/en/aboutun/copyright/index.html">
                  Copyright{' '}
                </a>
              </li>
              <li className="leaf">
                <a href="http://www.un.org/en/sections/aboutun/fraud-alert/index.html">
                  Fraud Alert
                </a>
              </li>
              <li className="leaf">
                <a href="http://www.un.org/en/sections/about-website/privacy-notice/index.html">
                  Privacy Notice
                </a>
              </li>
              <li className="last leaf">
                <a href="http://www.un.org/en/sections/about-website/terms-use/index.html">
                  Terms of Use
                </a>
              </li>
            </ul>
          </div>
        </section>
      </div>
    </div>
  </footer>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/common/Footer.js